/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUserChevron: {
  name: 'user-chevron';
  data: string;
} = {
  name: 'user-chevron',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM6 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm4 8a5 5 0 0 0-5 5 1 1 0 1 1-2 0 7 7 0 0 1 11.667-5.217 1 1 0 1 1-1.334 1.49A4.978 4.978 0 0 0 10 15Zm6.08 2h3.84a1 1 0 0 1 .78 1.625l-1.92 2.399a1 1 0 0 1-1.56 0l-1.92-2.4A1 1 0 0 1 16.08 17Z" fill="currentColor"/></svg>`,
};
